import React from "react";
import HanziWriter from "hanzi-writer";
import { Button, Col, Container, Row } from "react-bootstrap";
import StarRatings from 'react-star-ratings';

class WriteChinese extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 
      isComplete: false,
      score: 0,
      validChar:false,
      uid: Math.floor(Math.random() * Math.floor(10000)),
    };
  }

  componentDidMount() {
    this.writer = this.createHanziWritter(this.props.character, this.props.width);
    if(this.writer) {this.setState({ validChar:true });}
    this.startQuiz();
  }

  /**
   * Create a chinese charactor for display or test
   * @param {String} char, a single chinese character
   * @param {Integer} width, the width of the field to write the character
   */
  createHanziWritter = (char, width) => {
    let charDataLoader = null;
    try {
      charDataLoader = require("hanzi-writer-data/"+char);
      this.setState({ validChar: true });
    } catch(error) {
      console.log(error.message);
      this.setState({ validChar: false });
    }

    if (charDataLoader === null) {
      return null;
    }

    const writer = HanziWriter.create("grid-test"+this.state.uid, char, {
      charDataLoader: function() {
        return charDataLoader;
      },
      width: width,
      height: width,
      padding: 5*width/100,
      strokeColor: "#EE00FF",
      radicalColor: "#168F16",
      delayBetweenLoops: 3000,
      showOutline: this.props.showOutline,
      showCharacter: false,
      showHintAfterMisses: 3,
    });
    console.log("writer created!")
    return writer;
  }

  startQuiz =() => {
    console.log("quiz started");
    this.setState({isComplete: false, score: 0});
    let numberOfMistake = 0;
    let numberofSuccess = 0;
    if (this.writer===null) {
      return ;
    }
    this.writer.quiz({
      onMistake: (strokeData) => {
        numberOfMistake++;
      },
      onCorrectStroke: (strokeData) => {
        numberofSuccess++;
      },
      onComplete: (summaryData) => {
        console.log(numberofSuccess);
        this.setState({
          isComplete: true, 
          score: Math.floor(numberofSuccess/(numberOfMistake+numberofSuccess)*100)
        });
      }
    });
  }

  onClickStartOver = () => {
    console.log("start over");
    this.startQuiz();
  }

  render() {
    const width = this.props.width;

    return (
      <Container fluid style={{width: this.props.width}}>
        <Row>
          <Col>
            <svg 
              xmlns="http://www.w3.org/2000/svg"
              width={width} 
              height={width} 
              id={"grid-test"+this.state.uid}
            >
              <line x1="0" y1="0" x2={width} y2={width} stroke="#DDD" strokeDasharray="10" strokeWidth="2"/>
              <line x1={width} y1="0" x2="0" y2={width} stroke="#DDD" strokeDasharray="10" strokeWidth="2"/>
              <line x1={width/2} y1="0" x2={width/2} y2={width} stroke="#DDD" strokeDasharray="10" strokeWidth="2"/>
              <line x1="0" y1={width/2} x2={width} y2={width/2} stroke="#DDD" strokeDasharray="10" strokeWidth="2"/>
              <line x1="0" y1="0" x2={width} y2="000" stroke="#000" strokeWidth="5"/>
              <line x1="0" y1="0" x2="0" y2={width} stroke="#000" strokeWidth="5"/>
              <line x1="0" y1={width} x2={width} y2={width} stroke="#000" strokeWidth="5"/>
              <line x1={width} y1="0" x2={width} y2={width} stroke="#000" strokeWidth="5"/>
            </svg>
          </Col>
        </Row>
        {
          this.state.validChar && 
          <Row style={{paddingTop: "10px"}}>
            <Col xs={6}>
              <h5 className="text-info">Score: {this.state.score}/100</h5>
            </Col>
            <Col xs={6}>
              <Button 
                onClick={this.onClickStartOver}
                variant="outline-info"
                block
              >
                <i className="fas fa-redo-alt"></i> Try again
              </Button>
            </Col>
          </Row>
        }
        {
          this.state.validChar &&
          <Row style={{paddingTop: "10px"}}>
            <Col>
              <StarRatings
                rating={this.state.score/100*5}
                starRatedColor="gold"
                starEmptyColor="grey"
                numberOfStars={5}
                name='rating'
                starDimension="42px"
              />
            </Col>
          </Row>
        }
      </Container>
    );
  }

  static defaultProps = {
    character: "臡",
    width: 300,
    showOutline: true
};
}

export default WriteChinese;